/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NodeItem } from '../../models/node-item';

export interface ApiV0NodeitemRenameNodeItemPost$Params {
      body?: NodeItem
}

export function apiV0NodeitemRenameNodeItemPost(http: HttpClient, rootUrl: string, params?: ApiV0NodeitemRenameNodeItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0NodeitemRenameNodeItemPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0NodeitemRenameNodeItemPost.PATH = '/api/v0/nodeitem/renameNodeItem';
